module.exports = __webpack_public_path__ + "img/there-is-no-spoon.a1c9605b.png";